/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GetResourceDetailsResponse {
    getFixupPrototypeFunction() { return GetResourceDetailsResponse.fixupPrototype; }

    static newInstance(model: Partial<GetResourceDetailsResponse>): GetResourceDetailsResponse {
        let obj = Object.assign(new GetResourceDetailsResponse(), model);
        GetResourceDetailsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GetResourceDetailsResponse>): GetResourceDetailsResponse {
        if (!model) return null;
        return GetResourceDetailsResponse.newInstance(<GetResourceDetailsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GetResourceDetailsResponse) {
        if (!obj) return;

        models.GetResourceDetailsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GetResourceDetailsResponse): boolean {
        Object.setPrototypeOf(obj, GetResourceDetailsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Resource Details
     */
    data: any;

}
